//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const RenderRepeatsNearVisibility: FeatureFlag = {"Id":"RenderRepeatsNearVisibility","Label":"[10.18]Render repeats near visibility","Impact":"Delay repeater item rendering until the last item is close to the viewport to reduce initial render work.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
